import { colors, fonts } from "@edufadder/ui";

/** The EduFadder mark — same geometry as brand/logo-mark.svg. */
export function LogoMark({ size = 32, title }: { size?: number; title?: string }): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      width={size}
      height={size}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      style={{ flexShrink: 0, display: "block" }}
    >
      <rect x="0" y="0" width="128" height="128" rx="28" fill={colors.brand} />
      <line x1="80" y1="80" x2="106" y2="106" stroke={colors.gold} strokeWidth="16" strokeLinecap="round" />
      <circle cx="56" cy="56" r="32" fill={colors.brandHover} stroke={colors.gold} strokeWidth="12" />
      <path d="M40 57 L52 69 L73 45" fill="none" stroke="#ffffff" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Mark + wordmark, for headers. `onDark` switches the text to white for garnet backgrounds. */
export function Logo({ size = 32, onDark = false }: { size?: number; onDark?: boolean }): JSX.Element {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <LogoMark size={size} />
      <span
        style={{
          fontFamily: fonts.serif,
          fontWeight: 700,
          fontSize: Math.round(size * 0.66),
          color: onDark ? "#ffffff" : colors.brand,
          letterSpacing: "0.2px",
        }}
      >
        EduFadder
      </span>
    </span>
  );
}
